import React from 'react'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'

import { Fields } from '../components/index'

export default props => {
  const { formIndex, storeFormData, formData } = props

  const validationSchema = yup
    .object({
      firstName: yup.string().required('Please enter your first name'),
      middleName: yup.string(),
      lastName: yup.string().required('Please enter your last name'),
      dob: yup
        .string()
        .default(formData.dob ?? '')
        .matches(/^(\d{2}\/\d{2}\/\d{4})$/, 'Please enter a valid date of birth')
        .required('Please enter your date of birth'),
      homePhone: yup.string().matches(/^\d{10}$/, {
        message: 'Please enter a valid phone number',
        excludeEmptyString: true,
      }),
      mobile: yup
        .string()
        .length(10, 'Please enter a valid mobile number')
        .matches(/^\d{10}$/, 'Please enter a valid mobile number')
        .required('Please enter your mobile number'),
      email: yup
        .string()
        .email('Please enter a valid email address')
        .required('Please enter your email address'),
      confirmEmail: yup
        .string()
        .email('Please enter a valid email address')
        .oneOf([yup.ref('email'), null], "Email addresses don't match")
        .required('Please confirm your email address'),
    })
    .required()

  const formSchema = {
    sections: [
      {
        id: 'personal',
        title: 'Personal information',
        fieldKeys: ['firstName', 'middleName', 'lastName', 'dob'],
      },
      {
        id: 'contact',
        title: 'Contact details',
        fieldKeys: ['mobile', 'homePhone', 'email', 'confirmEmail'],
      },
    ],
    fields: [
      {
        id: 'firstName',
        label: 'First name *',
        autocomplete: 'given-name',
        type: 'text',
      },
      {
        id: 'middleName',
        label: 'Middle name',
        autocomplete: 'additional-name',
        type: 'text',
      },
      {
        id: 'lastName',
        label: 'Last name *',
        autocomplete: 'family-name',
        type: 'text',
      },
      {
        id: 'dob',
        label: 'Date of birth [DD/MM/YYYY] *',
        autocomplete: 'bday',
        type: 'date',
      },
      {
        id: 'mobile',
        label: 'Mobile *',
        autocomplete: 'tel',
        type: 'text',
      },
      {
        id: 'homePhone',
        label: 'Home phone',
        autoComplete: 'tel',
        type: 'text',
      },
      {
        id: 'email',
        label: 'Email address *',
        autocomplete: 'email',
        type: 'text',
      },
      {
        id: 'confirmEmail',
        label: 'Confirm email *',
        autocomplete: 'email',
        type: 'text',
      },
    ],
  }

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: formData,
    resolver: yupResolver(validationSchema),
  })

  const onSubmit = data => {
    storeFormData(formIndex, data)
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      {formSchema.sections.map(section => (
        <div className="formSection" key={`section-${section.id}`}>
          <h3>{section.title}</h3>

          {section.fieldKeys.map(fieldKey => {
            const props = formSchema.fields.filter(f => {
              return f.id === fieldKey
            })[0]
            const Component = Fields[props.type] ?? 'unknown'

            return (
              <Component
                key={fieldKey}
                field={props}
                control={control}
                register={register}
                errors={errors}
              />
            )
          })}
        </div>
      ))}

      <div className="formControls">
        <button className="button buttonNext" type="submit">
          Next
        </button>
      </div>
    </form>
  )
}
